/// <amd-module name="TFS/Admin/OrganizationAadControls/Components/AadResolvePanel/AadResolveLoadingPanel" />
import React = require("react");
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { ContentSize } from "VSSUI/Callout";
import { Panel } from "VSSUI/Panel";
import { VssComponent } from "VSS/Platform/Layout";
import { IAadResolveLoadingPanelComponentProps } from "TFS/Admin/OrganizationAadCommon/Contracts/ComponentControls.props";

export class AadResolveLoadingPanelComponent extends React.Component<IAadResolveLoadingPanelComponentProps> {
    public render(): JSX.Element {
        return (
            <Panel onDismiss={() => {}} size={ContentSize.Large}>
                <div className="width-100 loading-div">
                    <div>
                        <Spinner size={SpinnerSize.large} />
                    </div>
                    <div className="center-text-align top-margin">{this.props.loadingMessage}</div>
                </div>
            </Panel>
        );
    }
}

VssComponent.register("ms.vss-admin-web.aad-resolve-loading-panel", AadResolveLoadingPanelComponent);
